(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rescate-checkout-panitas"] && !Shopify.designMode) return;
  try {
    
(() => {
  const globalKey = '__panitasCheckoutRescue';

  if (window[globalKey]) {
    window[globalKey].refresh();
    return;
  }

  const state = {
    root: null,
    pendingUrl: null,
    busy: false,
    cart: null
  };

  const getRootPath = () => {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  };

  const refresh = () => {
    state.root = document.querySelector('[data-panitas-rescue]');
  };

  const getConfig = () => {
    if (!state.root) return null;

    return {
      enabled: state.root.dataset.enabled === 'true',
      testMode: state.root.dataset.testMode === 'true',
      minCart: Number(state.root.dataset.minCart || 0) * 100,
      requireItem: state.root.dataset.requireItem === 'true',
      minItem: Number(state.root.dataset.minItem || 0) * 100,
      excluded: String(state.root.dataset.excluded || '')
        .split(',')
        .map((value) => value.trim().toLowerCase())
        .filter(Boolean),
      discountCode: String(state.root.dataset.discountCode || '').trim(),
      onceSession: state.root.dataset.onceSession === 'true',
      currency: state.root.dataset.currency || 'COP'
    };
  };

  const getSessionKey = () => {
    if (!state.root) return 'panitas_rescue_seen';
    return `panitas_rescue_seen_${state.root.id}`;
  };

  const setupTestMode = () => {
    const params = new URLSearchParams(window.location.search);
    const value = params.get('panitas_rescate');

    if (value === '1') {
      sessionStorage.setItem('panitas_rescue_test', '1');
    }

    if (value === '0') {
      sessionStorage.removeItem('panitas_rescue_test');
      sessionStorage.removeItem(getSessionKey());
    }
  };

  const testModeAllowed = (config) => {
    if (!config.testMode) return true;
    return sessionStorage.getItem('panitas_rescue_test') === '1';
  };

  const formatMoney = (cents, currency) => {
    try {
      return new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency,
        maximumFractionDigits: 0
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return `$${Math.round(Number(cents || 0) / 100).toLocaleString('es-CO')}`;
    }
  };

  const fetchCart = async () => {
    const response = await fetch(`${getRootPath()}cart.js`, {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('No fue posible leer el carrito');
    }

    return response.json();
  };

  const itemIsEligible = (item, config) => {
    const title = String(item.product_title || item.title || '').toLowerCase();
    const excluded = config.excluded.some((word) => title.includes(word));
    const price = Number(item.final_price ?? item.price ?? 0);

    return !excluded && price >= config.minItem;
  };

  const cartIsEligible = (cart, config) => {
    if (!cart || Number(cart.item_count || 0) < 1) return false;
    if (Number(cart.total_price || 0) < config.minCart) return false;

    if (config.requireItem) {
      return Array.isArray(cart.items) && cart.items.some((item) => itemIsEligible(item, config));
    }

    return true;
  };

  const goToCheckout = (url) => {
    window.location.assign(url || `${getRootPath()}checkout`);
  };

  const openDialog = (cart, config) => {
    const dialog = state.root.querySelector('[data-pcr-dialog]');
    const current = state.root.querySelector('[data-pcr-current]');
    const minimum = state.root.querySelector('[data-pcr-minimum]');

    if (!dialog) {
      goToCheckout(state.pendingUrl);
      return;
    }

    if (current) {
      current.textContent = formatMoney(cart.total_price, cart.currency || config.currency);
    }

    if (minimum) {
      minimum.textContent = formatMoney(config.minCart, cart.currency || config.currency);
    }

    if (config.onceSession) {
      sessionStorage.setItem(getSessionKey(), '1');
    }

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', 'open');
    }
  };

  const attemptRescue = async (event, target) => {
    const config = getConfig();

    if (!config || !config.enabled || !testModeAllowed(config)) return;
    if (!config.discountCode) return;
    if (config.onceSession && sessionStorage.getItem(getSessionKey()) === '1') return;
    if (state.busy) {
      event.preventDefault();
      return;
    }

    const dynamicPayment = target.closest('.shopify-payment-button');
    if (dynamicPayment) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    state.busy = true;
    state.pendingUrl = target.tagName === 'A' && target.href
      ? target.href
      : `${getRootPath()}checkout`;

    try {
      state.cart = await fetchCart();

      if (!cartIsEligible(state.cart, config)) {
        goToCheckout(state.pendingUrl);
        return;
      }

      openDialog(state.cart, config);
    } catch (error) {
      goToCheckout(state.pendingUrl);
    } finally {
      state.busy = false;
    }
  };

  document.addEventListener('click', (event) => {
    refresh();
    if (!state.root) return;
    if (state.root.contains(event.target)) return;

    const target = event.target.closest(
      'a[href*="/checkout"], button[name="checkout"], input[name="checkout"], [data-panitas-checkout]'
    );

    if (!target) return;
    if (target.disabled || target.getAttribute('aria-disabled') === 'true') return;

    attemptRescue(event, target);
  }, true);

  document.addEventListener('submit', (event) => {
    refresh();
    if (!state.root) return;

    const submitter = event.submitter;
    if (!submitter) return;
    if (!submitter.matches('button[name="checkout"], input[name="checkout"], [data-panitas-checkout]')) return;

    attemptRescue(event, submitter);
  }, true);

  document.addEventListener('click', (event) => {
    refresh();
    if (!state.root || !state.root.contains(event.target)) return;

    const dialog = state.root.querySelector('[data-pcr-dialog]');
    const config = getConfig();

    if (event.target.closest('[data-pcr-close]')) {
      if (dialog && typeof dialog.close === 'function') dialog.close();
      return;
    }

    if (event.target.closest('[data-pcr-decline]')) {
      if (dialog && typeof dialog.close === 'function') dialog.close();
      goToCheckout(state.pendingUrl);
      return;
    }

    if (event.target.closest('[data-pcr-accept]')) {
      if (!config || !config.discountCode) {
        goToCheckout(state.pendingUrl);
        return;
      }

      const redirect = `${getRootPath()}checkout`;
      const discountUrl = `${getRootPath()}discount/${encodeURIComponent(config.discountCode)}?redirect=${encodeURIComponent(redirect)}`;
      window.location.assign(discountUrl);
    }
  });

  document.addEventListener('click', (event) => {
    refresh();
    if (!state.root) return;

    const dialog = state.root.querySelector('[data-pcr-dialog]');
    if (dialog && event.target === dialog && typeof dialog.close === 'function') {
      dialog.close();
    }
  });

  document.addEventListener('shopify:section:load', () => {
    refresh();
    setupTestMode();
  });

  refresh();
  setupTestMode();
  window[globalKey] = { refresh };
})();

  } catch(e) { console.error(e); }
})();
})();
